import {Component, OnInit} from '@angular/core';
import {PrefixService} from '../../../../services/frefix.service';
import {StepsControllerService} from '../../../../services/steps-controller.service';
import {StandardTypesService} from '../../../../services/standard-types.service';
import {StandardType} from '../../../../models/standard-type.model';
import {AdminService} from '../../../../services/admin.service';
import {UserService} from '../../../../services/user.service';
import {ConfirmationPopupComponent} from '../../../views/view-group/popups/confirmation-popup/confirmation-popup.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NewBlank} from '../../../../models/new-blank.model';
import {ApiConnectService} from '../../../../services/api-connect.service';
import {ViewDocxComponent} from '../../../views/view-docx/view-docx.component';
import {ViewDocxService} from '../../../../services/view-docx.service';
import {AddStandardTypeComponent} from '../../create-standard/modal/add-standard-type/add-standard-type.component';
import {EditStandardTypeComponent} from '../../create-standard/modal/edit-standard-type/edit-standard-type.component';


@Component({
  selector: 'app-opst-step-four',
  templateUrl: './opst-step-four.component.html',
  styleUrls: ['./opst-step-four.component.css']
})
export class OpstStepFourComponent implements OnInit {
  showChat = true;
  showFilesAndBlanks = false;
  isLoaded = true;
  thisStandard: any;
  newBlanks: NewBlank[] = [];
  removedUsersIDList: any[] = [];
  okModifyMsg = false;
  // showByFilesAndBlanks = false;

  usersAndGroups: any;
  stringDate: string;
  acknowledgementDays = 5;
  acknowledgementDaysTemp = null;
  showDiscussionBtn = false;
  showTable = false;
  isReadOnly = false;
  goBtnIsClicked = false;
  isLoadedStep = false;
  tableUsers: any[] = [];
  selectedType: StandardType;
  groupStandardId: string;
  users: any;
  groups: any;
  groupsHead: any;
  currentUserID: string;
  isUploadDisabled = false;
  newRuName = '';
  newEnName = '';
  newRuAn = '';
  newEnAn = '';
  formData: FormData = new FormData();

  selectedForExecute: any = [];
  selectedForConfirm: any = [];
  selectedGroupForExecute: any = [];
  selectedPosForExecute: any = [];
  selectedPosForEConfirm: any = [];
  selectedGroupHeadForConfirm: any = [];

  foundUser = false;
  foundPos = false;
  foundGroup = false;
  foundUserConfirm = false;
  foundPosConfirm = false;
  foundGroupConfirm = false;

  // RUS
  isNewRuDoc = false;
  isNewRuPpt = false;
  isNewRuPdf = false;
  fileRuDoc: File = null;
  fileRuPpt: File = null;
  fileRuPdf: File = null;
  // ENG
  isNewEnDoc = false;
  isNewEnPpt = false;
  isNewEnPdf = false;
  fileEnDoc: File = null;
  fileEnPpt: File = null;
  fileEnPdf: File = null;

  showSFiles = false;
  showUTable = false;
  showDessiminStn = false;

  constructor(public prefixService: PrefixService,
              public viewDocxService: ViewDocxService,
              public stepsControllerService: StepsControllerService,
              public standardTypesService: StandardTypesService,
              private adminService: AdminService,
              private apiConnectService: ApiConnectService,
              private userService: UserService,
              private modalService: NgbModal) {
  }

  ngOnInit() {
    this.stepsControllerService.activeStep = 4;
    
    if (this.stepsControllerService.getCurrentStandard()) {
      this.thisStandard = this.stepsControllerService.getCurrentStandard();
      if (this.thisStandard.status === 'UNDER_CONFIRMATION') {

      }
    } else {
      this.thisStandard = null;
    }

    this.userService.getActiveUsers().subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.users = response.body;
        }
      },
      () => {
      }
    );

    this.adminService.getAllGroups().subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.groups = response.body;
        }
      },
      () => {
      }
    );

    this.standardTypesService.updateAllTypes();

    this.newRuName = this.thisStandard.ruName;
    this.newEnName = this.thisStandard.enName;
    this.newRuAn = this.thisStandard.ruAnnotation;
    this.newEnAn = this.thisStandard.enAnnotation;

    // Установить выбранными пользователей для исполнения
    if (this.thisStandard.linkedUsers.length > 0) {
      for (const userExecute of this.thisStandard.linkedUsers) {
        this.selectItem(userExecute);
      }
    }

    // Установить выбранными пользователей для утверждения
    if (this.thisStandard.confirmedUsers.length > 0) {
      for (const userForConfirm of this.thisStandard.confirmedUsers) {
        this.fieldsChangeTmp(userForConfirm);
      }
    }

    // Установить выбранными группы для исполнения
    if (this.thisStandard.linkedGroups.length > 0) {
      for (const groupExecute of this.thisStandard.linkedGroups) {
        this.selectGroupItem(groupExecute);
      }
    }

    // Установить выбранными группы для утверждения
    if (this.thisStandard.confirmedGroups.length > 0) {
      for (const groupForConfirm of this.thisStandard.confirmedGroups) {
        this.fieldsChangeGroupHeadTmp(groupForConfirm);
      }
    }

    // Установить выбранными позиции для исполнения
    if (this.thisStandard.linkedPositions.length > 0) {
      for (const posExecute of this.thisStandard.linkedPositions) {
        this.selectPosItem(posExecute);
      }
    }

    // Установить выбранными позиции для утверждения
    if (this.thisStandard.confirmedPositions.length > 0) {
      for (const posForConfirm of this.thisStandard.confirmedPositions) {
        this.fieldsChangePosTmp(posForConfirm);
      }
    }

    this.currentUserID = localStorage.getItem('User');
    this.getUserTable();
  }

  shTable() {
    this.showUTable = !this.showUTable;
  }

  shFiles() {
    this.showSFiles = !this.showSFiles;
  }

  getUserTable() {
    this.isLoaded = false;
    this.stepsControllerService.getConfirmatoriesInfo(this.stepsControllerService.getCurrentStandard().id).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.tableUsers = response.body;
          this.isLoaded = true;
        }
      },
      () => {
        this.isLoaded = true;
      }
    );
  }

  isValid() {
    if (this.thisStandard.language === 'russian') {
      return (
        this.newRuName !== '' && this.newRuName !== null
        && this.newRuAn !== '' && this.newRuAn !== null &&
        this.formData.has('RU_DOC') &&
        this.checkListsLength());

    } else if (this.thisStandard.language === 'english') {
      return (
        this.newEnName !== '' && this.newEnName !== null
        && this.newEnAn !== '' && this.newEnAn !== null &&
        this.formData.has('EN_DOC') &&
        this.checkListsLength());
    }

  }

  checkListsLength() {
    return (this.selectedGroupForExecute.length > 0
      || this.selectedGroupHeadForConfirm.length > 0
      || this.selectedForExecute.length > 0
      || this.selectedForConfirm.length > 0
      || this.selectedPosForExecute.length > 0
      || this.selectedPosForEConfirm.length > 0);
  }

  setType(typeID) {
    const typeObj = this.standardTypesService.getTypesList().find(i => i.id === typeID);
    this.standardTypesService.setSelectedType(typeObj);
    this.selectedType = typeObj;
  }

// ПРОВЕРКА ВЫБРАН ЛИ ЭЛЕМЕНТ
  selectItem(user) {
    if (this.isSelectedUser(user)) {
      const index = this.selectedForExecute.findIndex(x => x.id === user.id);
      if (index !== -1) {
        this.selectedForExecute.splice(index, 1);
      }
    } else {
      this.selectedForExecute.push(user);
    }
  }

  selectPosItem(pos) {
    if (this.isSelectedPos(pos)) {
      const index = this.selectedPosForExecute.findIndex(x => x.id === pos.id);
      if (index !== -1) {
        this.selectedPosForExecute.splice(index, 1);
      }
    } else {
      this.selectedPosForExecute.push(pos);
    }
  }

  selectGroupItem(group) {
    if (this.isSelectedGroup(group)) {
      const index = this.selectedGroupForExecute.findIndex(x => x.id === group.id);
      if (index !== -1) {
        this.selectedGroupForExecute.splice(index, 1);
      }
    } else {
      this.selectedGroupForExecute.push(group);
    }
  }

  isSelectedUser(user) {
    this.foundUser = false;
    if (this.selectedForExecute.length > 0) {
      for (const grp of this.selectedForExecute) {
        if (grp.id === user.id) {
          this.foundUser = true;
          break;
        }
      }
    }
    return this.foundUser;
  }

  isSelectedPos(pos) {
    this.foundPos = false;
    if (this.selectedPosForExecute.length > 0) {
      for (const grp of this.selectedPosForExecute) {
        if (grp.id === pos.id) {
          this.foundPos = true;
          break;
        }
      }
    }
    return this.foundPos;
  }

  isSelectedGroup(group) {
    this.foundGroup = false;
    if (this.selectedGroupForExecute.length > 0) {
      for (const grp of this.selectedGroupForExecute) {
        if (grp.id === group.id) {
          this.foundGroup = true;
          break;
        }
      }
    }
    return this.foundGroup;
  }

  isSelectedUserConfirm(user) {
    this.foundUserConfirm = false;
    if (this.selectedForConfirm.length > 0) {
      for (const grp of this.selectedForConfirm) {
        if (grp.id === user.id) {
          this.foundUserConfirm = true;
          break;
        }
      }
    }
    return this.foundUserConfirm;
  }

  isSelectedGroupHeadConfirm(group) {
    this.foundGroupConfirm = false;
    if (this.selectedGroupHeadForConfirm.length > 0) {
      for (const grp of this.selectedGroupHeadForConfirm) {
        if (grp.id === group.id) {
          this.foundGroupConfirm = true;
          break;
        }
      }
    }
    return this.foundGroupConfirm;
  }

  isSelectedPosConfirm(pos) {
    this.foundPosConfirm = false;
    if (this.selectedPosForEConfirm.length > 0) {
      for (const grp of this.selectedPosForEConfirm) {
        if (grp.id === pos.id) {
          this.foundPosConfirm = true;
          break;
        }
      }
    }
    return this.foundPosConfirm;
  }

  // CONFIRMED
  fieldsChange(values: any, user) {
    if (values.currentTarget.checked) {
      if (!this.isSelectedUserConfirm(user)) {
        this.selectedForConfirm.push(user);
      }
    } else {
      if (this.isSelectedUserConfirm(user)) {
        const index = this.selectedForConfirm.findIndex(x => x.id === user.id);
        if (index !== -1) {
          this.selectedForConfirm.splice(index, 1);
        }
      }
    }
  }

  fieldsChangeTmp(user) {
    if (!this.isSelectedUserConfirm(user)) {
      this.selectedForConfirm.push(user);
    }
  }

  fieldsChangeGroupHead(values: any, group) {
    if (values.currentTarget.checked) {
      if (!this.isSelectedGroupHeadConfirm(group)) {
        this.selectedGroupHeadForConfirm.push(group);
      }
    } else {
      if (this.isSelectedGroupHeadConfirm(group)) {
        const index = this.selectedGroupHeadForConfirm.findIndex(x => x.id === group.id);
        if (index !== -1) {
          this.selectedGroupHeadForConfirm.splice(index, 1);
        }
      }
    }
  }

  fieldsChangeGroupHeadTmp(group) {
    if (!this.isSelectedGroupHeadConfirm(group)) {
      this.selectedGroupHeadForConfirm.push(group);
    }
  }

  fieldsChangePos(values: any, pos) {
    if (values.currentTarget.checked) {
      if (!this.isSelectedPosConfirm(pos)) {
        this.selectedPosForEConfirm.push(pos);
      }
    } else {
      if (this.isSelectedPosConfirm(pos)) {
        const index = this.selectedPosForEConfirm.findIndex(x => x.id === pos.id);
        if (index !== -1) {
          this.selectedPosForEConfirm.splice(index, 1);
        }
      }
    }
  }

  fieldsChangePosTmp(pos) {
    if (!this.isSelectedPosConfirm(pos)) {
      this.selectedPosForEConfirm.push(pos);
    }
  }

  deleteBlankFile(blank) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DYWTDTBF';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        this.adminService.deleteBlankFromStandard(blank, this.stepsControllerService.currentStandard).subscribe(
          (response: any) => {
            if (response.status === 200) {
              this.stepsControllerService.showByFilesAndBlanks = true;
              const index = this.thisStandard.blanks.indexOf(blank);
              this.thisStandard.blanks.splice(index, 1);
            }
          },
          () => {
          }
        );
      }
    });
  }

  downloadFile(id) {
    this.isLoaded = false;
    this.userService.getFile(id).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }, () => {
        this.isLoaded = true;
      }
    );
  }

  openPdfStnd(fileId: string) {
    window.open(this.apiConnectService.getPdf + fileId, '_blank');
  }

  deleteFile(fileId: string, type: string) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DO_YOU_WANT_TO_DELETE_THIS_STANDARD';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        this.adminService.deleteFileFromStandard(fileId, type, this.thisStandard).subscribe(
          (response: any) => {
            if (response.status === 200) {
              switch (type) {
                case 'RU_DOC': {
                  this.thisStandard.ruDoc = null;
                  break;
                }
                case 'RU_PPT': {
                  this.thisStandard.ruPpt = null;
                  break;
                }
                case 'RU_PDF': {
                  this.thisStandard.ruPdf = null;
                  break;
                }
                case 'EN_DOC': {
                  this.thisStandard.enDoc = null;
                  break;
                }
                case 'EN_PPT': {
                  this.thisStandard.enPpt = null;
                  break;
                }
                case 'EN_PDF': {
                  this.thisStandard.enPdf = null;
                  break;
                }
              }
            }
          },
          () => {
          }
        );
      }
    });
  }

  fileChange(typeFile, event) {
    if (typeFile === 'RU_PPT') {
      if (event.target.files.length > 0) {
        this.fileRuPpt = event.target.files[0];
        this.isNewRuPpt = true;
      } else {
        this.fileRuPpt = null;
        this.isNewRuPpt = false;
      }
    }

    if (typeFile === 'RU_DOC') {
      if (event.target.files.length > 0) {
        this.fileRuDoc = event.target.files[0];
        this.isNewRuDoc = true;
      } else {
        this.fileRuDoc = null;
        this.isNewRuDoc = false;
      }
    }

    if (typeFile === 'RU_PDF') {
      if (event.target.files.length > 0) {
        this.fileRuPdf = event.target.files[0];
        this.isNewRuPdf = true;
      } else {
        this.fileRuPdf = null;
        this.isNewRuPdf = false;
      }
    }

    if (typeFile === 'EN_PPT') {
      if (event.target.files.length > 0) {
        this.fileEnPpt = event.target.files[0];
        this.isNewEnPpt = true;
      } else {
        this.fileEnPpt = null;
        this.isNewEnPpt = false;
      }
    }
    if (typeFile === 'EN_DOC') {
      if (event.target.files.length > 0) {
        this.fileEnDoc = event.target.files[0];
        this.isNewEnDoc = true;
      } else {
        this.fileEnDoc = null;
        this.isNewEnDoc = false;
      }
    }
    if (typeFile === 'EN_PDF') {
      if (event.target.files.length > 0) {
        this.fileEnPdf = event.target.files[0];
        this.isNewEnPdf = true;
      } else {
        this.fileEnPdf = null;
        this.isNewEnPdf = false;
      }
    }
  }

  openDocModalDOCX(fileLink) {
    localStorage.setItem('fileLink', fileLink);

    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxIDManually();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxIDManually();
    });
  }

  deleteFileDOCX(sid, fileLink, type) {
    this.adminService.deleteTempDocxFileManually(fileLink, sid).subscribe(
      (res: any) => {
        if (type === 'RU_DOC') {
          this.thisStandard.ruDoc = null;
          this.thisStandard.ruFileLink = null;
        } else if (type === 'EN_DOC') {
          this.thisStandard.enDoc = null;
          this.thisStandard.enFileLink = null;
        }
      },
      () => {
      }
    );
  }

  uploadFile(typeFile) {
    this.isUploadDisabled = true;
    if (typeFile === 'RU_PPT') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileRuPpt, this.fileRuPpt.name);
      this.adminService.uploadFiles(this.thisStandard, formData).subscribe(
        () => {
          this.adminService.getStandard(this.thisStandard.id).subscribe(
            (response: any) => {
              this.thisStandard.ruPpt = response.body.ruPpt;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }
    if (typeFile === 'RU_DOC') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileRuDoc, this.fileRuDoc.name);
      this.adminService.uploadFiles(this.thisStandard, formData).subscribe(
        () => {
          this.adminService.getStandard(this.thisStandard.id).subscribe(
            (response: any) => {
              this.thisStandard.ruDoc = response.body.ruDoc;
              this.thisStandard.ruPdf = response.body.ruPdf;
              this.thisStandard.ruFileLink = response.body.ruFileLink;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }
    if (typeFile === 'RU_PDF') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileRuPdf, this.fileRuPdf.name);
      this.adminService.uploadFiles(this.thisStandard, formData).subscribe(
        () => {
          this.adminService.getStandard(this.thisStandard.id).subscribe(
            (response: any) => {
              this.thisStandard.ruPdf = response.body.ruPdf;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }
    if (typeFile === 'EN_PDF') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileEnPdf, this.fileEnPdf.name);
      this.adminService.uploadFiles(this.thisStandard, formData).subscribe(
        () => {
          this.adminService.getStandard(this.thisStandard.id).subscribe(
            (response: any) => {
              this.thisStandard.enPdf = response.body.enPdf;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }
    if (typeFile === 'EN_DOC') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileEnDoc, this.fileEnDoc.name);
      this.adminService.uploadFiles(this.thisStandard, formData).subscribe(
        () => {
          this.adminService.getStandard(this.thisStandard.id).subscribe(
            (response: any) => {
              this.thisStandard.enDoc = response.body.enDoc;
              this.thisStandard.enPdf = response.body.enPdf;
              this.thisStandard.enFileLink = response.body.enFileLink;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }
    if (typeFile === 'EN_PPT') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileEnPpt, this.fileEnPpt.name);
      this.adminService.uploadFiles(this.thisStandard, formData).subscribe(
        () => {
          this.adminService.getStandard(this.thisStandard.id).subscribe(
            (response: any) => {
              this.thisStandard.enPpt = response.body.enPpt;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }
  }

  addNewBlank() {
    this.newBlanks.push(new NewBlank(null, null, null));
  }

  blanksChange(event, index: number) {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const formData = new FormData();
      formData.append('file', file, file.name);
      this.newBlanks[index].formData = formData;
    }
  }

  // checkInputBlanks(inputValue) {
  //   if (inputValue) {
  //     this.isSaveBlankDisabled = false;
  //   } else {
  //     this.isSaveBlankDisabled = true;
  //   }
  // }

  validationBlank(blank) {
    return blank.number !== null && blank.number.trim() !== '' &&
      blank.name !== null && blank.name.trim() !== '' &&
      blank.formData;
  }

  saveBlank(index) {
    if (this.validationBlank(this.newBlanks[index])) {
      this.stepsControllerService.showByFilesAndBlanks = false;
      this.adminService.uploadBlank(this.thisStandard, [this.newBlanks[index]]).subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.stepsControllerService.showByFilesAndBlanks = true;
            this.thisStandard.blanks.push(response.body[0]);
            this.newBlanks.splice(index, 1);
          }
        }
      );
    }
  }

// deleteBlank
  deleteBlankStepFour(key) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DYWTDTB';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        if (key > -1) {
          this.newBlanks.splice(key, 1);
        }
      }
    });
  }


  areStandardsCompared() {
    if (this.standardTypesService.getSelectedType()) {
      return this.newRuName === this.thisStandard.ruName &&
        this.newRuAn === this.thisStandard.ruAnnotation &&
        this.newEnName === this.thisStandard.enName &&
        this.newEnAn === this.thisStandard.enAnnotation &&
        this.standardTypesService.getSelectedType().id === this.thisStandard.standardType.id &&
        this.removedUsersIDList.length === 0;
    } else {
      return true;
    }
  }


  reworkStandard() {
    this.okModifyMsg = false;

    const modifedStandard = {
      id: this.stepsControllerService.getCurrentStandard().id,
      ruName: this.newRuName,
      ruAnnotation: this.newRuAn,
      enName: this.newEnName,
      enAnnotation: this.newEnAn,
      type: {
        id: this.standardTypesService.getSelectedType().id,
        ruName: this.standardTypesService.getSelectedType().ruName,
        enName: this.standardTypesService.getSelectedType().enName
      },
      deletedUserId: this.removedUsersIDList
    };

    this.stepsControllerService.doModifications(modifedStandard).subscribe(
      (res: any) => {
        if (res.status === 200) {
          this.thisStandard = res.body;
          this.stepsControllerService.setCurrentStandard(this.thisStandard);

          this.getUserTable();
          this.removedUsersIDList = [];
          this.stepsControllerService.showByFilesAndBlanks = false;
          this.okModifyMsg = true;
        }
      },
      () => {
      }
    );
  }

  removeUser(userid) {
    if (!this.isSelectedUserForRemove(userid)) {
      this.removedUsersIDList.push(userid);
    } else {
      // Восстановленние пользователя;
      const index = this.removedUsersIDList.findIndex(x => x === userid);
      if (index !== -1) {
        this.removedUsersIDList.splice(index, 1);
      }
    }
  }

  isSelectedUserForRemove(uID) {
    let foundForRemove = false;
    if (this.removedUsersIDList.length > 0) {
      for (const rID of this.removedUsersIDList) {
        if (rID === uID) {
          foundForRemove = true;
          break;
        }
      }
    }
    return foundForRemove;
  }

  shBlock(s) {
    switch (s) {
      case 'sc':
        this.showChat = !this.showChat;
        break;
      case 'sfab':
        this.showFilesAndBlanks = !this.showFilesAndBlanks;
        break;
      case 'sds':
        this.showDessiminStn = !this.showDessiminStn;
        break;

    }
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-four/opst-step-four.component.ts